import { PanelbarStructure } from "../isPanelbarDetails";
import { Helper } from "../../util/helper";
import { StringKeyDictionary } from "../../../commonInterfaces";
import React from "react";

export default class UserDetails extends React.Component<any, any> {
    private translations: StringKeyDictionary<string> = {};


    componentDidMount() {
        Helper.getTranslations(["Login.Benutzername", "Field.Ressource.name", "Field.Ressource.obergruppe", "Field.Ressource.gruppe", "Field.Adresse.telefon", "Field.Adresse.email"])
            .then(result => {
                if (Helper.hasValue(result)) {
                    this.translations = result.Data;
                    this.setState({});
                }
            });
    }

    render() {
        const data = this.props.data;
        return (
            <PanelbarStructure label={data.Name2} keyPropValue={data.Name} iconName={"user-alt"}>
                <table className="templateHoverTable">
                    <tbody>
                        <tr>
                            <td>
                                <span>{data.Obergruppe}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Gruppe}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Tel}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{data.Email}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </PanelbarStructure>
        );
    }
}